import { createSlice } from "@reduxjs/toolkit";
import isOutdated from "../utils/isOutdated";
import cafeService from "../service/cafe.service";

const cafesSlice = createSlice({
  name: "cafes",
  initialState: {
    entities: [],
    isLoading: true,
    error: null,
    lastFetch: null,
  },
  reducers: {
    cafesRequested: (state) => {
      state.isLoading = true;
    },
    cafesReceived: (state, action) => {
      state.entities = action.payload;
      state.lastFetch = Date.now();
      state.isLoading = false;
    },
    cafesRequestFailed: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

const { reducer: cafesReducer, actions } = cafesSlice;
const { cafesRequested, cafesReceived, cafesRequestFailed } = actions;

export const loadCafesList = (payload) => async (dispatch, getState) => {
  const { lastFetch } = getState().cafes;
  if (isOutdated(lastFetch)) {
    dispatch(cafesRequested());
    try {
      const { content } = await cafeService.get(payload);
      dispatch(cafesReceived(content));
    } catch (error) {
      dispatch(cafesRequestFailed(error.message));
    }
  }
};

export const getCafes = () => (state) => state.cafes.entities;
export const getCafesLoadingStatus = () => (state) => state.cafes.isLoading;
export const getCafeById = (id) => (state) => {
  if (state.cafes.entities) {
    return state.cafes.entities.find((p) => p._id === id);
  }
};

export default cafesReducer;
